import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import ModalInput from '../controls/ModalInput';
import { toast } from 'react-toastify';
import ModalConfirm from '../controls/ModalConfirm';
import ModalUpload from '../controls/ModalUpload';
import EstateEdit from '../controls/EstateEdit';
import { Redirect } from 'react-router-dom';
import PropertiesContainer from './PropertiesContainer';


const RequestPrices = (props) => {
    let [data, setData] = useState([]);
    let [showModal, setShowModal] = useState(false);
    let [editData, setEditData] = useState({ rowNo: 0, price: 0, isFast: false });

    const fetchData = async () => {

        Comm.Instance().get(`requesttype`).then(result => {
            setData(result.data);

        }).catch(error => Tools.ProcessError(error))
    };

    useEffect(() => {

        fetchData();
    }, []);

    const saveToServer = (element) => {
        Comm.Instance().post('requesttype', element).then(r => {
            fetchData();
            setShowModal(false);
            toast.info("Промяната е отразена");
        });
    }

    const savePrice = (value) => {

        let element = { ...data[editData.rowNo] };
        switch (editData.field) {
            case "fastprice": element.fastPrice = parseFloat(value); break;
            case "normalprice": element.normalPrice = parseFloat(value); break;
            case "fastterm": element.fastTerm = parseInt(value); break;
            case "normalterm": element.normalTerm = parseInt(value); break;
            default: break;
        }
        
        saveToServer(element);
    }

    const saveFastAllowed = (rowNo) => {

        let element = { ...data[rowNo] };
        element.allowFast = !element.allowFast;

        saveToServer(element);
    }

    const startEdit = (rowNo, field, value, label) => {
        editData.rowNo = rowNo;
        editData.field = field;
        editData.value = value;
        editData.label = label;
        setEditData({ ...editData });
        setShowModal(true);
    }



    return (
        <>
            <div className="container">
                <h2 className="appeal-title mb-5">Редакция на цени на услуги</h2>
                {/*<p>{JSON.stringify(editData)}</p>*/}
                <div className="form-row">
                    <div className="form-group col-md-7">
                        <b>Услуга</b>
                    </div>
                    <div className="form-group col-md-1">
                        <b>Експресна?</b>
                    </div>
                    <div className="form-group col-md-1">
                        <b>Нормална цена</b>
                    </div>
                    <div className="form-group col-md-1">
                        <b>Експресна цена</b>
                    </div>
                    <div className="form-group col-md-1">
                        <b>срок Нормална</b>
                    </div>
                    <div className="form-group col-md-1">
                        <b>срок Експресна</b>
                    </div>
                </div>
                {
                    data.map((i, ix) =>
                        <div className="form-row" key={ix}>
                            <div className="form-group col-md-7">
                                {i.title}
                            </div>
                            <div className="form-group col-md-1">
                                <input type="checkbox" checked={i.allowFast} onChange={()=>saveFastAllowed(ix)}/>
                            </div>
                            <div className="form-group col-md-1">
                                <button onClick={() => startEdit(ix, "normalprice", i.normalPrice, "Цена")}>{i.normalPrice} лв</button>
                            </div>
                            <div className="form-group col-md-1">
                                {i.allowFast && <button onClick={() => startEdit(ix, "fastprice", i.fastPrice, "Цена")}>{i.fastPrice} лв</button>}
                            </div>
                            <div className="form-group col-md-1">
                                <button onClick={() => startEdit(ix, "normalterm", i.normalPrice, "Срок")}>{i.normalTerm} дни</button>
                            </div>
                            <div className="form-group col-md-1">
                                {i.allowFast && <button onClick={() => startEdit(ix, "fastterm", i.fastPrice, "Срок")}>{i.fastTerm} дни</button>}
                            </div>
                        </div>
                    )
                }

            </div>
            <ModalInput display={showModal} closeFunc={() => setShowModal(false)} saveFunc={(x) => savePrice(x)} value={editData.price} dataType="number" title={editData.label} />

        </>

    );
}


export default RequestPrices;

